module.exports = __webpack_public_path__ + "static/img/main_product.ec9c8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/main_product.png
// module id = 6CQy
// module chunks = 0